import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

const GiftCardOrderSuccess = ({ urls }) => (
  <Fragment>
    <p>
      <strong>Merci pour votre achat et votre confiance.</strong>
    </p>
    <p>
      Vous allez recevoir par e-mail la carte cadeau avec votre message
      personnalisé si vous l’avez spécifié.
    </p>
    <p>
      Vous pourrez ainsi directement l’imprimer pour le donner en main propre ou
      transférer l’e-mail directement au bénéficiaire.
    </p>
    <p>
      Vous avez également la possibilité de télécharger la carte cadeau en vous
      rendant{' '}
      <a href={urls.giftCardOrderURL}>
        {' '}
        sur la page dédiée à votre carte cadeau
      </a>
      .
    </p>
  </Fragment>
)

GiftCardOrderSuccess.propTypes = {
  urls: PropTypes.object.isRequired
}

export default GiftCardOrderSuccess
